import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import * as R from "ramda";
import { getBearerToken } from "utils/platformAuth";

export const authenticatedFetch = async (uri, options = {}) => {
  const bearerToken = await getBearerToken();
  const optionsWithToken = R.mergeDeepRight(options, {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
    },
  });
  const response = await fetch(uri, optionsWithToken);

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return response;
};

export const partnersClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      IndexedPromotionalProperty: {
        keyFields: ["id", "searchTerms"],
      },
      IndexedPublisher: {
        keyFields: ["id", "searchTerms"],
      },
    },
  }),
  devtools: {
    enabled: process.env.NODE_ENV === "local",
  },
  link: new HttpLink({
    uri: process.env.REACT_APP_PARTNERS_API_URL,
    fetch: authenticatedFetch,
  }),
});

export const accountsClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri: process.env.REACT_APP_ACCOUNTS_API_URL,
    fetch: authenticatedFetch,
  }),
});
